import React, { useContext, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import AuthContext from "../../Context/auth/AuthContext";
const EditBirthdateModal = ({ open, onClose, onSave, id }) => {
  const { saveBirthDate } = useContext(AuthContext);
  const [birthdate, setBirthdate] = useState("");

  const handleChange = (e) => {
    setBirthdate(e.target.value);
  };

  const handleSave = () => {
    if (birthdate) {
      saveBirthDate({ birthdate: birthdate, id: id });
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Selecciona tu fecha de nacimiento</DialogTitle>
      <DialogContent>
        <TextField
          type='date'
          fullWidth
          margin='normal'
          value={birthdate}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant='outlined'>
          Cancelar
        </Button>
        <Button onClick={handleSave} variant='contained'>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditBirthdateModal;
